module.exports = __webpack_public_path__ + "img/logo-orange.931a9a74.png";